import { render } from "./BulkTracking.vue?vue&type=template&id=5852b649&scoped=true"
import script from "./BulkTracking.vue?vue&type=script&lang=ts"
export * from "./BulkTracking.vue?vue&type=script&lang=ts"

import "./BulkTracking.vue?vue&type=style&index=0&id=5852b649&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5852b649"

export default script